"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketLifecycleConfigurationInput_1 = require("./GetBucketLifecycleConfigurationInput");
var GetBucketLifecycleConfigurationOutput_1 = require("./GetBucketLifecycleConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketLifecycleConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketLifecycleConfiguration",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?lifecycle"
    },
    input: {
        shape: GetBucketLifecycleConfigurationInput_1.GetBucketLifecycleConfigurationInput
    },
    output: {
        shape: GetBucketLifecycleConfigurationOutput_1.GetBucketLifecycleConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketLifecycleConfiguration.js.map